/* MC quick filter chips: the best selling chip drives the existing sort select so the theme's AJAX filtering handles it. */
document.addEventListener('click', function (event) {
  var chip = event.target.closest && event.target.closest('[data-mc-sort]');
  if (!chip) return;
  var form = chip.closest('facet-filters-form');
  var select = form && form.querySelector('select[name="sort_by"]');
  if (!select) return;
  var active = chip.classList.contains('is-active');
  var target = active ? chip.getAttribute('data-mc-sort-reset') || 'manual' : chip.getAttribute('data-mc-sort');
  select.value = target;
  select.dispatchEvent(new Event('input', { bubbles: true }));
});

/* Price range chips: set or clear the price filter parameters and let the theme's AJAX filtering re-render. */
document.addEventListener('click', function (event) {
  var chip = event.target.closest && event.target.closest('[data-mc-price]');
  if (!chip || typeof FacetFiltersForm === 'undefined') return;
  var params = new URLSearchParams(window.location.search);
  params.delete('page');
  params.delete('filter.v.price.gte');
  params.delete('filter.v.price.lte');
  if (!chip.classList.contains('is-active')) {
    if (chip.dataset.mcGte) params.set('filter.v.price.gte', chip.dataset.mcGte);
    if (chip.dataset.mcLte) params.set('filter.v.price.lte', chip.dataset.mcLte);
  }
  FacetFiltersForm.renderPage(params.toString());
});
